import * as React from 'react';

import { usePrevious } from '@notino/react-web-utils';

import { PhotoWithReview } from '../store/createPhotosStore';

export const useRestoreGridScroll = (
  selectedPhoto: PhotoWithReview | undefined
) => {
  const prevSelectedPhoto = usePrevious(selectedPhoto);
  const imageRefs = React.useRef<Record<string, HTMLButtonElement>>({});

  React.useEffect(() => {
    if (!selectedPhoto && prevSelectedPhoto) {
      const imgEl = imageRefs.current[prevSelectedPhoto.fullSizeUrl];
      imgEl?.scrollIntoView({
        behavior: 'instant' as ScrollBehavior,
        block: 'center',
      });
    }
  }, [prevSelectedPhoto, selectedPhoto]);

  return { imageRefs };
};

export const findPrevReviewLastPhoto = (
  photos: PhotoWithReview[],
  currentIndex: number
) => {
  for (let i = currentIndex - 1; i >= 0; i--) {
    if (photos[i].reviewId !== photos[currentIndex].reviewId) {
      return photos[i];
    }
  }
  return null;
};

export const findNextReviewFirstPhoto = (
  photos: PhotoWithReview[],
  currentIndex: number
) => {
  for (let i = currentIndex + 1; i < photos.length; i++) {
    if (photos[i].reviewId !== photos[currentIndex].reviewId) {
      return photos[i];
    }
  }
  return null;
};
